// /js/stores/index.js
import { createPinia } from 'pinia';
import { useSalonStore } from './salon.js';
import { useCustomerBookingStore } from './customerBooking.js';

const pinia = createPinia();

export function initializeStores() {
  try {
    // Instantiating registers the store — the call is the initialization.
    useSalonStore();

    // Initialize customer booking store
    const customerBookingStore = useCustomerBookingStore();

    // Set up online/offline event listeners for customer booking store
    window.addEventListener('online', () => {
      customerBookingStore.updateOnlineStatus(true);
    });

    window.addEventListener('offline', () => {
      customerBookingStore.updateOnlineStatus(false);
    });

    console.debug('[stores] Vitrina stores initialized');
  } catch (error) {
    console.error('[stores] Error initializing stores:', error);
  }
}

export default pinia;
